import ietdavv from "./assets/icons/ietdavv.png";
import gujaratisamaj from "./assets/icons/gujaratisamaj.jpg"

const all_education = [{
    logo: ietdavv ,
    degree: "Bachelors of Engineering in Information Technology",
    institute: "Institute of Engineering and Technology, DAVV",
    grades: "CGPA: 7.3 (till 6th Semester)"
},{
    logo: gujaratisamaj ,
    degree: "Higher Secondary Education",
    institute: "Shri Gujarati Samaj A.M.N. School",
    grades: `Higher Secondary Education (Class 12th): 83% <br> Secondary Education (Class 10th): 88%`
}]

export default all_education;